module.exports = __webpack_public_path__ + "img/icon_2_1.92c07766.png";